import { Box, Stack, Typography } from "@mui/material";
import TelephoneHelpIcon from "../../assets/icons/telephoneHelp.svg";
import TelephoneIcon from "../../assets/icons/telephone.svg";
import { Alert } from "../Alert";
import { renderToString } from "react-dom/server";
import { IsDevice } from "../../utils";

export const TelephoneInfo = ({ description, telephoneData }) => {
  const descProccessed = proccessDescription(telephoneData?.textDescription);

  const { IsMobile } = IsDevice();

  return (
    <Stack
      sx={{
        flexDirection: "row",
        justifyContent: "end",
        width: "98%",
        mb: 1,
        position: "absolute",
        bottom: IsMobile ? 50 : 1,
        right: 15,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          "&:hover": { cursor: "pointer" },
        }}
        onClick={() => {
          Alert({
            icon: <img src={TelephoneIcon} alt="icon" width={"70px"} />,
            title: telephoneData.title,
            okbtntext: "Cerrar",
            html: renderToString(
              <Box>
                <Typography
                  textAlign={"left"}
                  variant="body2"
                  sx={{ mt: 1, textAlign: "left", maxWidth: 400, mx: "auto" }}
                  dangerouslySetInnerHTML={{
                    __html: descProccessed,
                  }}
                ></Typography>
              </Box>
            ),
          });
        }}
      >
        <Box sx={{ border: "1px solid black", p: 1, borderRadius: "100px" }}>
          <img src={TelephoneHelpIcon} alt="icon" width={"25px"} />
        </Box>
        <Typography sx={{ marginTop: "5px", fontSize: "12px !important" }}>
          {description}
        </Typography>
      </Box>
    </Stack>
  );
};

const proccessDescription = (text) => {
  if (!!!text) return "";

  const toSearch = "al ";
  const index = text.indexOf(toSearch);

  const part1 = text.slice(0, index + toSearch.length);
  const part2 = text.slice(index + toSearch.length);
  const finalText = `${part1} <br>${part2}`;
  return finalText;
};
